import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import {
  createBikesDetailsSlice,
  BikesDetailsSlice,
} from './storeSlices/bikesDetails';
import {
  createBikesLocationSlice,
  BikesLocationSlice,
} from './storeSlices/bikesLocation';
import {
  createYourDetailsSlice,
  YourDetailsSlice,
} from './storeSlices/yourDetails';

export const useBikesStore = create<
  YourDetailsSlice & BikesDetailsSlice & BikesLocationSlice
>()(
  persist(
    (...a) => ({
      ...createBikesDetailsSlice(...a),
      ...createBikesLocationSlice(...a),
      ...createYourDetailsSlice(...a),
    }),
    {
      name: 'report-it-bikes-storage', // name of the item in the storage (must be unique)
    },
  ),
);
